import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './FeedbackForm.css';

const FeedbackThankYou = () => {
  const { batchNumber } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  
  const { userRating, previousCount } = location.state || {};
  
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    // Load batch stats
    const loadStats = async () => {
      try {
        const response = await axios.get(`/api/feedback/batch/${batchNumber}/stats`);
        setStats(response.data);
        setLoading(false);
      } catch (err) {
        console.error('Failed to load stats', err);
        setLoading(false);
      }
    };
    
    loadStats();
  }, [batchNumber]);
  
  return (
    <div className="feedback-form-container">
      <div className="thank-you-container">
        <h1>Thank You!</h1>
        
        <div className="thank-you-message">
          <p>Your feedback helps us create better beverages.</p>
          {previousCount > 1 && (
            <p className="repeat-taster">
              You've now tasted this batch {previousCount} times!
            </p>
          )}
        </div>
        
        {loading && <div className="loading">Loading stats...</div>}
        
        {!loading && stats && stats.total_responses > 0 && (
          <div className="feedback-stats">
            <h2>Your Rating vs. Others</h2>
            
            <div className="stat-comparison">
              <div className="stat-box">
                <div className="stat-value">{userRating}/10</div>
                <div className="stat-label">Your Rating</div>
              </div>
              
              <div className="stat-box">
                <div className="stat-value">
                  {stats.avg_ratings.overall_enjoyment.toFixed(1)}/10
                </div>
                <div className="stat-label">
                  Batch Average<br/>
                  ({stats.total_responses} {stats.total_responses === 1 ? 'response' : 'responses'})
                </div>
              </div>
            </div>
            
            {stats.common_taste_descriptors.length > 0 && (
              <div className="common-descriptors">
                <h3>Most Common Taste Descriptors:</h3>
                <div className="descriptor-tags">
                  {stats.common_taste_descriptors.slice(0, 5).map(d => (
                    <span key={d.descriptor} className="descriptor-tag">
                      {d.descriptor} ({d.count})
                    </span>
                  ))}
                </div>
              </div>
            )}
            
            {stats.common_aroma_descriptors.length > 0 && (
              <div className="common-descriptors">
                <h3>Most Common Aroma Descriptors:</h3>
                <div className="descriptor-tags">
                  {stats.common_aroma_descriptors.slice(0, 5).map(d => (
                    <span key={d.descriptor} className="descriptor-tag">
                      {d.descriptor} ({d.count})
                    </span>
                  ))}
                </div>
              </div>
            )}
            
            {Object.keys(stats.ingredient_avg_ratings).length > 0 && (
              <div className="ingredient-stats">
                <h3>Average Ingredient Ratings:</h3>
                <div className="ingredient-ratings-list">
                  {Object.entries(stats.ingredient_avg_ratings)
                    .sort((a, b) => b[1] - a[1])
                    .map(([ingredient, rating]) => (
                      <div key={ingredient} className="ingredient-rating-item">
                        <span className="ingredient-name">{ingredient}</span>
                        <span className="ingredient-rating">{rating.toFixed(1)}/10</span>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        )}
        
        <div className="thank-you-actions">
          <button 
            className="submit-button"
            onClick={() => navigate(`/feedback/${batchNumber}`)}
          >
            Submit Another Review
          </button>
          <button 
            className="secondary-button"
            onClick={() => navigate('/')}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackThankYou;
